<script setup lang="ts">
import { computed, type Component } from "vue";
import { Info, CircleCheckBig, AlertCircle, Quote } from "lucide-vue-next";

const props = defineProps({
  html: { type: String, default: "" },
  variant: { type: String, default: "info" },
});

const VARIANT_CONFIG: Record<string, { wrapper: string; icon: Component | null; iconClass: string }> = {
  info: {
    wrapper: "bg-status-info-soft rounded-lg px-3.5 py-3 flex items-start gap-2.5",
    icon: Info,
    iconClass: "text-status-info",
  },
  success: {
    wrapper: "bg-status-success-soft rounded-lg px-3.5 py-3 flex items-start gap-2.5",
    icon: CircleCheckBig,
    iconClass: "text-status-success-strong",
  },
  warning: {
    wrapper: "bg-status-warning-soft rounded-lg px-3.5 py-3 flex items-start gap-2.5",
    icon: AlertCircle,
    iconClass: "text-status-warning",
  },
  quote: {
    wrapper: "relative rounded-lg bg-muted py-3 pl-9 pr-3.5 italic",
    icon: Quote,
    iconClass: "absolute left-3 top-3.5 -scale-x-100 text-foreground-subtle",
  },
  none: {
    wrapper: "",
    icon: null,
    iconClass: "",
  },
};

const config = computed(() => VARIANT_CONFIG[props.variant] || VARIANT_CONFIG.none);
</script>

<template>
  <div :class="config.wrapper">
    <component
      :is="config.icon"
      v-if="config.icon"
      class="h-4 w-4 shrink-0 mt-0.5"
      :class="config.iconClass"
    />
    <div
      class="prose prose-sm max-w-none text-13 text-foreground leading-relaxed prose-p:my-0 prose-ul:my-1 prose-ol:my-1 prose-li:my-0 [&_p:empty]:h-[1lh]"
      v-html="html"
    />
  </div>
</template>
